import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "table-wrapper" }
const _hoisted_4 = { class: "date-labels" }
const _hoisted_5 = { class: "child-row__name" }
const _hoisted_6 = { class: "table-item col-name" }
const _hoisted_7 = { class: "table-item col-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: '園提供サービス', href: '/school-service', color: 'primary' },
          { title: '月間の利用確認' },
        ]
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_page_title, { value: "園提供サービス 月間の利用確認" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_month_pager, {
        modelValue: _ctx.yearMonth,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "usage-table",
        style: _normalizeStyle(_ctx.tableStyle)
      }, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "date-label col-name" }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "date-label col-date" }, "月額", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateLabels, (d) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "date-label col-date",
              key: d
            }, _toDisplayString(d), 1))
          }), 128))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenWithUsages, (cwu) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "child-row",
            key: cwu.child.childId
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(cwu.child.lastName) + " " + _toDisplayString(cwu.child.firstName), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cwu.services, (service) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "child-row_items",
                key: service.service.uniqueServiceId
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(service.service.uniqueServiceName.length > 13 ? service.service.uniqueServiceName.slice(0, 23) + '…' : service.service.uniqueServiceName), 1),
                _createElementVNode("div", _hoisted_7, [
                  (service.isMonthly)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (service.isMonthlyUsed)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "primary"
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_icon, {
                              key: 1,
                              color: "#c8c8c8"
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-circle-outline", -1)
                              ]))]),
                              _: 1
                            }))
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service.usages, (usage) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "table-item col-date",
                    key: usage.date
                  }, [
                    (!service.isMonthly)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (usage.hasUsed)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("mdi-check-circle", -1)
                                ]))]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                color: "#c8c8c8"
                              }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("mdi-circle-outline", -1)
                                ]))]),
                                _: 1
                              }))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
        }), 128))
      ], 4)
    ])
  ]))
}